<template>
  <div>
    <div class="p-6 pb-0">
      <BreadCrumbs :navigation="navigation" />
    </div>
    <div class="p-6 pb-0">
      <div class="flex items-center justify-between mb-4">
        <label class="block text-sm font-medium mb-2">{{ $t('gm.list_client_orders') }}</label>
      </div>

      <PageServerTable
        :headers="headers" 
        :items="items" 
        :items-per-page.sync="ipp" 
        :items-per-page-options="ippo" 
        :sort-by="sortby" 
        :items-length="count" 
        :reload-fn="reload"
        :mobile-filter-exclusions="['select']"

        show-select
        v-model.selected="selected"
        :item-value="'SaleOrdId'"

        :page="page"
        show-current-page
        >
        <template #item.OrderDate="{ item }">
            <span>
              {{ formatDate(item.OrderDate) }}
            </span>
        </template>
        <template #item.Customer="{ item }">
            <span>
              {{ item.CompanyName ?? item.Customer }}
            </span>
        </template>
      </PageServerTable>
      <div class="pb-24"></div>
    </div>
    <div class="fixed left-0 right-0 bottom-0 flex justify-center items-center pointer-events-none">
      <div class="flex gap-2 pointer-events-auto bg-white w-full px-4 py-3 justify-center">
        <button v-if="selected.length == 0" class="text-white bg-blue-400 cursor-not-allowed font-medium rounded-lg text-sm px-5 py-2.5 text-center">{{ $t('core.load') }}</button>
        <button v-if="selected.length > 0" class="text-white bg-blue-400 hover:bg-blue-500 font-medium rounded-lg text-sm px-5 py-2.5 text-center" @click="loadOrdersData">{{ $t('core.load') }} {{ selected.map(x=>x.InternalOrdNo).join(", ") }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { Link, router, useForm } from '@inertiajs/vue3';
import BreadCrumbs from '@/Components/BreadCrumbs.vue';
import Pagination from '@/Components/Pagination.vue';
import PageServerTable from '@/Components/PageServerTable.vue';

export default {
  props: ['items', 'count', 'ippo'],
  components: {
    Link,
    BreadCrumbs,
    Pagination,
    PageServerTable
  },
  data() {
    return {
      search: this.filters?.search || "",
      navigation: [
        { name: 'Dashboard', href: route('dashboard') },
        { name: this.$t('modules.gestione-magazzino'), href: route('modules.home', 'gestione-magazzino') },
        { name: this.$t('core.order_fulfillment'), href: route('modules.gm.evasione') }
      ],
      selected: [],
      //deletions: [],

      headers: [],
      sortby: [],
      ipp: 10,
      page: 1
    };
  },
  methods: {
    reload(sortby = undefined, itemsperpage = undefined, page = undefined, afterdeletion = false) {
      /*if (afterdeletion)
      return;*/

        if (sortby) this.sortby = sortby;
        if (itemsperpage) this.ipp = itemsperpage;
        if (page) this.page = page;

        //sortBy e ipp passano solo il valore aggiornato come $event, non si modifica realmente, quindi ricaricare le prop
        router.post(window.location.href, { headers: this.headers, sortby: this.sortby, itemsperpage: this.ipp, page: this.page}, { only: ['items', 'count']});
    },

    loadOrdersData()
    {
      router.post(route('modules.gm.evadiDettagli'), { ids: this.selected.map(x=>x.SaleOrdId)}, { only: ['items', 'count'], preserveUrl: true});
    }
  },
  mounted()
  {
    //Primo caricamento
    this.headers = this.$attrs.headers;
    this.ipp = this.$attrs.ipp;
    this.page = this.$attrs.page;
    this.sortby = this.$attrs.sortby;
  }
};
</script>